(function () {

  var SVG_CHECK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"' +
    ' class="mod_app_js_components_add_to_cart_button_CBbO3G_AddToCart_icon"' +
    ' style="width:1em;height:1em;vertical-align:middle;margin-right:.4em">' +
    '<path d="M10.5616 15.9077L16.9577 9.51155L16.25 8.80385L10.5616 14.4923L7.71155' +
    ' 11.6423L7.00385 12.35L10.5616 15.9077ZM12.0034 21C10.7588 21 9.58872 20.7638' +
    ' 8.4931 20.2915C7.39748 19.8192 6.44444 19.1782 5.63397 18.3685C4.82352 17.5588' +
    ' 4.18192 16.6066 3.70915 15.512C3.23638 14.4174 3 13.2479 3 12.0033C3 10.7588' +
    ' 3.23616 9.58872 3.70848 8.4931C4.18081 7.39748 4.82183 6.44444 5.63153 5.63398' +
    'C6.44123 4.82353 7.39337 4.18192 8.48795 3.70915C9.58255 3.23638 10.7521 3' +
    ' 11.9966 3C13.2412 3 14.4113 3.23616 15.5069 3.70848C16.6025 4.18081 17.5556' +
    ' 4.82182 18.366 5.63152C19.1765 6.44122 19.8181 7.39337 20.2908 8.48795C20.7636' +
    ' 9.58255 21 10.7521 21 11.9967C21 13.2412 20.7638 14.4113 20.2915 15.5069' +
    'C19.8192 16.6025 19.1782 17.5556 18.3685 18.366C17.5588 19.1765 16.6066 19.8181' +
    ' 15.512 20.2908C14.4174 20.7636 13.2479 21 12.0034 21Z" fill="#f1f1f1"/></svg>';

  function getBtn(form) {
    return form.querySelector('button[type="submit"]');
  }

  function managedBundleCard(form) {
    var card = form.closest('[data-mw-bundle-card-state]');
    var state = card && card.dataset.mwBundleCardState;
    return state === 'available' || state === 'unavailable' ? card : null;
  }

  function handleBundleAction(form, event) {
    var card = managedBundleCard(form);
    if (!card) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (card.dataset.mwBundleCardState === 'available') {
      var link = card.querySelector('a[data-mw-bundle-cta]');
      if (link) window.location.href = link.href;
    }
    return true;
  }

  function setAdded(form) {
    var btn = getBtn(form);
    if (!btn) return;
    if (!btn.dataset.originalLabel) {
      btn.dataset.originalLabel = btn.innerHTML;
    }
    btn.innerHTML = SVG_CHECK + 'Added';
    btn.classList.add('added');
    btn.classList.remove('owned');
    btn.disabled = true;
  }

  function resetAdded(form) {
    var btn = getBtn(form);
    if (!btn) return;
    btn.innerHTML = form.dataset.mwCompletionDestinationHandle
      ? '<span class="product-quick-add__text">View collection offer</span>'
      : (btn.dataset.originalLabel || (form.dataset.mwUpgradeDefinitionId
        ? '<span class="product-quick-add__text">Upgrade</span>'
        : '<span class="product-quick-add__text">Add to cart</span>'));
    btn.classList.remove('added');
    btn.classList.remove('owned');
    btn.disabled = false;
  }

  function setCompletionReferral(form, referral) {
    var btn = getBtn(form);
    if (!btn || !referral) return;
    form.dataset.mwCompletionDestinationHandle = referral.destination_handle;
    btn.textContent = 'View collection offer';
    btn.classList.remove('added');
    btn.classList.remove('owned');
    btn.disabled = false;
  }

  function setOwnedPill(card) {
    var target = (card && card.querySelector('.grid-product__pills')) || card;
    if (target && !target.querySelector('.grid-product-owned-pill')) {
      var pill = document.createElement('div');
      pill.className = 'grid-product-owned-pill';
      pill.textContent = 'Owned';
      target.appendChild(pill);
    }
  }

  function setOwned(form) {
    var btn = getBtn(form);
    if (!btn) return;
    btn.textContent = 'Owned';
    btn.classList.add('owned');
    btn.classList.remove('added');
    btn.disabled = false;
    var card = form.closest('.grid-product__content');
    setOwnedPill(card);
  }

  function checkOwnedState() {
    if (!window.MW_IS_LOGGED_IN) return;
    var ownedHandles = window.MW_getOwnedHandles ? window.MW_getOwnedHandles() : new Set();
    if (!ownedHandles.size) return;
    document.querySelectorAll('.grid-product[data-product-handle]').forEach(function (card) {
      if (ownedHandles.has(card.dataset.productHandle)) setOwnedPill(card.querySelector('.grid-product__content'));
    });
    document.querySelectorAll('form[data-product-quick-add]').forEach(function (form) {
      if (managedBundleCard(form)) return;
      var handle = form.dataset.productHandle;
      if (handle && ownedHandles.has(handle)) setOwned(form);
    });
  }

  function checkCartState() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ownedHandles = window.MW_IS_LOGGED_IN && window.MW_getOwnedHandles
          ? window.MW_getOwnedHandles() : new Set();
        var inCartIds = cart.items.map(function (item) { return item.variant_id; });
        document.querySelectorAll('form[data-product-quick-add]').forEach(function (form) {
          if (managedBundleCard(form)) return;
          var input = form.querySelector('[name="id"]');
          if (!input) return;
          var vid = parseInt(input.value, 10);
          var card = form.closest('.grid-product[data-product-id]');
          var productId = form.dataset.productId || (card && card.dataset.productId);
          var offerResult = productId && window.MWProductOffers
            ? window.MWProductOffers.getForProduct(productId)
            : null;
          var activeUpgrade = offerResult && offerResult.best && offerResult.best.type === 'upgrade'
            ? offerResult.best
            : null;
          var activeReferral = offerResult && offerResult.referral
            ? offerResult.referral
            : null;
          var offerInCart = activeUpgrade && window.MWProductOffers.cartContainsOffer
            ? window.MWProductOffers.cartContainsOffer(activeUpgrade, cart)
            : false;
          if (activeReferral) {
            setCompletionReferral(form, activeReferral);
          } else if (offerInCart || (!activeUpgrade && inCartIds.indexOf(vid) !== -1)) {
            setAdded(form);
          } else {
            var handle = form.dataset.productHandle;
            if (ownedHandles.size && handle && ownedHandles.has(handle)) {
              setOwned(form);
            } else {
              var btn = getBtn(form);
              if (btn && btn.classList.contains('added')) resetAdded(form);
            }
          }
        });
      })
      .catch(function (err) { console.error('[pqa] checkCartState:', err); });
  }

  document.addEventListener('click', function (e) {
    var form = e.target.closest('form[data-product-quick-add]');
    if (!form) return;
    if (handleBundleAction(form, e)) return;

    var btn = getBtn(form);
    if (btn && btn.classList.contains('owned')) {
      e.preventDefault();
      var handle = form.dataset.productHandle;
      if (handle) window.location.href = '/products/' + handle;
      return;
    }

    e.stopPropagation();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-product-quick-add]')) return;
    if (handleBundleAction(form, e)) return;

    e.preventDefault();
    e.stopPropagation();

    var btn = getBtn(form);
    if (!btn) return;

    if (btn.classList.contains('owned')) {
      var handle = form.dataset.productHandle;
      if (handle) window.location.href = '/products/' + handle;
      return;
    }

    var card = form.closest('.grid-product[data-product-id]');
    var productId = form.dataset.productId || (card && card.dataset.productId);
    var offerResult = productId && window.MWProductOffers
      ? window.MWProductOffers.getForProduct(productId)
      : null;
    var delegatedUpgrade = offerResult && offerResult.best &&
      offerResult.best.type === 'upgrade' && offerResult.best.variant_id;
    if ((offerResult && offerResult.referral) || delegatedUpgrade) return;

    btn.classList.add('is-loading');

    var data = new FormData(form);

    fetch(
      (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: data
      }
    )
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json && json.status === 422) {
          console.warn('[pqa] add failed:', json);
          return;
        }

        setAdded(form);

        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: json, addToCartBtn: btn }
        }));
      })
      .catch(function (err) { console.error('[pqa] fetch error:', err); })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  });

  document.addEventListener('DOMContentLoaded', function () { checkOwnedState(); checkCartState(); });
  document.addEventListener('ajaxProduct:added', function () { checkOwnedState(); checkCartState(); });
  document.addEventListener('shopify:section:load', function () { checkOwnedState(); checkCartState(); });
  document.addEventListener('collection:reloaded', function () { checkOwnedState(); checkCartState(); });
  document.addEventListener('recommendations:loaded', function () { checkOwnedState(); checkCartState(); });

  document.addEventListener('change', function (e) {
    if (e.target.matches('form[data-product-quick-add] select[name="id"]')) {
      checkOwnedState();
      checkCartState();
    }
  });
})();
